import { SearchMode as ApiSearchMode } from "@/api/files";

export type SearchMode = "standard" | "ai";

export interface DriveSearchFormInputs {
  query: string;
}

export const mapSearchModeToApi = (mode: SearchMode | null): ApiSearchMode => (mode === "ai" ? "meaning" : "title");
